import register from '@kpsys/angularjs-register';
import SearchInputComponent from './kp-search-input.component';
import SearchInputServiceProvider from './search-input.provider';

/**
 * @ngdoc module
 * @name portaro.components.search-input
 * @module portaro.components.search-input
 */

export default register('portaro.components.input-search')
    .provider(SearchInputServiceProvider.providerName, SearchInputServiceProvider)
    .component(SearchInputComponent.componentName, SearchInputComponent)
    .name();
